import { render, staticRenderFns } from "./SampleForm.vue?vue&type=template&id=6dd4fd72"
import script from "./SampleForm.vue?vue&type=script&lang=js"
export * from "./SampleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports